'use strict';

class PricingFeatures {

    constructor() {

        const featuresTable = document.querySelector( ".pricing-plans-features-list" );

        // halt execution when component is not on this page

        if ( !featuresTable ) return false;

        // utility functions

        const getNextSibling = ( elem, selector ) => {
            let sibling = elem.nextElementSibling;
            if ( !selector ) return sibling;

            while ( sibling ) {
                if ( sibling.matches( selector ) ) return sibling;
                sibling = sibling.nextElementSibling;
            }
        }

        const addClass = ( elem, className ) => {
            if ( !elem.classList.contains( className ) ) {
                elem.classList.add( className );
            }
        }

        const removeClass = ( elem, className ) => {
            if ( elem.classList.contains( className ) ) {
                elem.classList.remove( className );
            }
        }

        const getOffsetTop = ( elem ) => {
            return elem.getBoundingClientRect().top;
        }

        const getOffsetBottom = ( elem ) => {
            return elem.getBoundingClientRect().bottom;
        }

        const closeFeature = ( toggle, rows ) => {
            if ( rows.length > 0 ) {
                removeClass( toggle.parentNode, "open" );

                for ( const row of rows ) {
                    row.style.display = "none";
                }
            }
        }

        const openFeature = ( toggle, rows ) => {
            if ( rows.length > 0 ) {
                addClass( toggle.parentNode, "open" );

                for ( const row of rows ) {
                    row.style.display = "table-row";
                }
            }
        }

        // constants

        const tableHeader = featuresTable.querySelector( "thead" );
        const features = featuresTable.querySelectorAll( ".feature" );
        const tablePinOffset = getOffsetBottom( document.querySelector( ".main-header" ) );
        const featurePinOffset = tablePinOffset * 2;

        // handles sticky state of table header and feature headings

        const handlePinnedState = () => {

            if ( getOffsetBottom( featuresTable ) < 0 ) return;

            if ( getOffsetTop( featuresTable ) < tablePinOffset ) {
                addClass( tableHeader, "thead-pinned" );
            } else {
                removeClass( tableHeader, "thead-pinned" );
            }

            if ( features.length > 0 ) {

                for ( const feature of features ) {

                    if ( getOffsetTop( feature ) < featurePinOffset ) {
                        addClass( feature, "feature-title-pinned" );
                    } else {
                        removeClass( feature, "feature-title-pinned" );
                    }

                    const last = getNextSibling( feature, ".last-row" );
                    if ( getOffsetTop( last ) < tablePinOffset ) {
                        removeClass( feature, "feature-title-pinned" );
                    }

                }

            }

        }

        // sets click event on feature header to open/close feature groups

        if ( features.length > 0 ) {

            for ( const feature of features ) {

                const toggle = feature.querySelector( "h5" );
                const rows = featuresTable.querySelectorAll( "tr." + toggle.id );

                // closes all feature groups and keeps first group open
                if ( feature !== features[ 0 ] ) {
                    closeFeature( toggle, rows );
                }

                toggle.addEventListener( "click", () => {

                    const featuresTable = document.querySelector( ".pricing-plans-features-list" );
                    if ( !featuresTable ) return false;

                    if ( rows.length > 0 ) {

                        if ( toggle.parentNode.classList.contains( "open" ) ) {

                            closeFeature( toggle, rows );
                        } else {

                            openFeature( toggle, rows );
                        }

                    }

                } );

            }

        }

        // throttles the scroll event

        let scrollY = 0;
        let ticking = false;

        document.addEventListener( "scroll", () => {
            scrollY = window.scrollY;
            if ( !ticking ) {
                window.requestAnimationFrame( () => {
                    handlePinnedState( scrollY );
                    ticking = false;
                } );
                ticking = true;
            }
        } );

    }

}

module.exports = PricingFeatures;
